export const PREVIEW_PROBLEM_LEFT_WIDTH = 50;
export const PREVIEW_PROBLEM_CONTENT_LATERAL_PADDING = 20;
export const PREVIEW_PROBLEM_INSTRUCTION_BOTTOM_MARGIN = 32;
export const PREVIEW_PROBLEM_LEFT_PADDINGTOP = 5;
export const PREVIEW_PROBLEM_LEFT_LINEHEIGHT = 1.5;
export const PREVIEW_PROBLEM_RIGHT_PADDINGTOP = 5;

export const SUBPROBLEM_LATERAL_LEFT_PADDING =
  PREVIEW_PROBLEM_CONTENT_LATERAL_PADDING;
export const SUBPROBLEM_BOTTOM_MARGIN = 40;
export const SUBPROBLEM_INPUT_VERTICAL_MARGIN = 10;
export const SUBPROBLEM_LEFT_WIDTH = PREVIEW_PROBLEM_LEFT_WIDTH;
